function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M563.2 836.266667c-3.413333 0-10.24 0-13.653333-3.413334l-136.533334-136.533333c-6.826667-6.826667-6.826667-17.066667 0-23.893333s17.066667-6.826667 23.893334 0l136.533333 136.533333c6.826667 6.826667 6.826667 17.066667 0 23.893333 0 3.413333-6.826667 3.413333-10.24 3.413334z",
  fill: "#fb9b25",
  "p-id": 6003
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M426.666667 836.266667c-3.413333 0-10.24 0-13.653334-3.413334-6.826667-6.826667-6.826667-17.066667 0-23.893333l136.533334-136.533333c6.826667-6.826667 17.066667-6.826667 23.893333 0s6.826667 17.066667 0 23.893333l-136.533333 136.533333c0 3.413333-6.826667 3.413333-10.24 3.413334z",
  fill: "#fb9b25",
  "p-id": 6004
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M791.893333 768h-23.893333c-10.24 0-17.066667-6.826667-17.066667-17.066667s6.826667-17.066667 17.066667-17.066666h23.893333c109.226667 0 197.973333-88.746667 197.973334-197.973334S901.12 341.333333 791.893333 341.333333c-6.826667 0-20.48-6.826667-20.48-13.653333-20.48-136.533333-139.946667-242.346667-279.893333-242.346667C334.506667 85.333333 204.8 211.626667 204.8 368.64c0 10.24 0 23.893333 3.413333 40.96 0 3.413333 0 10.24-3.413333 13.653333-3.413333 3.413333-10.24 6.826667-13.653333 6.826667h-3.413334C102.4 426.666667 34.133333 494.933333 34.133333 580.266667s68.266667 153.6 153.6 153.6h34.133334c10.24 0 17.066667 6.826667 17.066666 17.066666s-6.826667 17.066667-17.066666 17.066667h-34.133334C85.333333 768 0 682.666667 0 580.266667c0-98.986667 75.093333-177.493333 174.08-187.733334v-27.306666c0-174.08 143.36-317.44 317.44-317.44 153.6 0 283.306667 109.226667 314.026667 256 122.88 6.826667 221.866667 105.813333 221.866666 228.693333-3.413333 133.12-109.226667 235.52-235.52 235.52z",
  fill: "#fb9b25",
  "p-id": 6005
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M494.933333 972.8C372.053333 972.8 273.066667 873.813333 273.066667 750.933333s98.986667-221.866667 221.866666-221.866666S716.8 628.053333 716.8 750.933333s-98.986667 221.866667-221.866667 221.866667z m0-409.6C392.533333 563.2 307.2 648.533333 307.2 750.933333s85.333333 187.733333 187.733333 187.733334S682.666667 853.333333 682.666667 750.933333s-85.333333-187.733333-187.733334-187.733333z",
  fill: "#fb9b25",
  "p-id": 6006
});

var SvgEmptyIcon = function SvgEmptyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1628442332325,
    className: "icon",
    viewBox: "0 0 1027 1024",
    "p-id": 6002,
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyIcon.26038bab.svg";
export { ForwardRef as ReactComponent };